<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'serieProposalModule.serie' | translate }}
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div>
    <serie-proposal-item-table
      *ngIf="serieProposal$ | async"
      [tableData]="serieProposalItems$ | async"
      [serieProposal]="serieProposal$ | async"
      [isLoading]="isLoading"
      [bulkActions]="
        fromInitialRequest ||
        (serieProposal$ | async).status == proposalStatus.ACCEPTED
          ? []
          : [bulkAction.ACCEPT, bulkAction.DECLINE]
      "
      [activePage]="page"
      [pageCount]="pageCount"
      [limitPage]="limit"
      [total]="total"
      [showTotal]="true"
      [refreshData$]="refreshData$.asObservable()"
      [intersectingBookings]="intersectingBookings"
      (onBulkAction)="onBulkAction($event)"
      (onClickRow)="onClickRow($event)"
      (onSearchTerm)="onSearchTerm($event)"
      (onSelectedPage)="selectNewPage($event)"
      (onSelectLimit)="selectNewLimit($event)"
    >
    </serie-proposal-item-table>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
